import qs from 'querystring';

/**
 * Builds API request URL with parameters
 * @param {Object} personalizedPaymentParams - Payment parameters
 * @param creditTypeValue
 * @param creditLowScore
 * @param paymentCalculationUrl
 * @returns {string} Complete API URL
 */
const buildApiUrl = (personalizedPaymentParams, creditTypeValue, creditLowScore, paymentCalculationUrl) => {
  const queryParams = {
    ...personalizedPaymentParams,
    // Pass low credit score only when user select 'rebuilding' aka 'poor' credit
    ...(creditTypeValue === 'rebuilding' && creditLowScore && {
      creditLowScore
    })
  };
  return paymentCalculationUrl + `&${qs.stringify(queryParams)}`;
};
export { buildApiUrl as default };
